import { TranslationKeys } from '~/hooks/useLocalization';
import type { MainAppState } from '~/state/mainAppState';
import type { PresentableText } from './types/PresentableText';

export const presentCompanyName = (state: MainAppState): PresentableText => {
  const name = state.user.companyInfo?.name;
  return name ? { text: name } : { key: TranslationKeys.LANDLORD_VERIFICATION_YOUR_PROPERTY_MANAGER };
};
